import Image, { type ImageProps } from 'next/image';

import { clc } from '@/legacy/components/base/utils';

import styles from '@/legacy/components/img/Img.module.scss';

type Props = {
	alt?: string;
};

const Img = ({ src, alt, className, ...props }: Omit<ImageProps, 'alt'> & Props) => {
	return (
		<Image
			alt={alt ? alt : 'image'}
			className={clc(styles['img'], className)}
			fill
			src={src}
			style={{ objectFit: 'cover' }}
			{...props}
		/>
	);
};

export default Img;
